import { I18n } from "@/i18n/I18n";

export const formatDate = (dateString?: string | Date) => {
  if (!dateString) return I18n.get('notApplicable');
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

export function parseLocalDateString(dateStr: string): string {
  const [year, month, day] = dateStr.split('T')[0].split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
